import request from '@/utils/request'

let ShareApi = {
  // 获取分享商品列表
  getsharegoodsList(data, errorback) {
    return request._post('/shop/plus.sharepolite.SharePolite/getShareGoodsList', data, errorback);
  },
  // 获取分享商品
  getsharegoods(data, errorback) {
    return request._post('/shop/plus.sharepolite.SharePolite/getShareGoods', data, errorback);
  },
  // 获取设置属性
  getset(data, errorback) {
    return request._post('/shop/plus.sharepolite.SharePolite/getSet', data, errorback);
  },

  //修改设置
  set(data, errorback) {
    return request._post('/shop/plus.sharepolite.SharePolite/editSet', data, errorback);
  },

  // 条件查询分享记录
  queryShareRecord(data, errorback) {
    return request._post('/shop/plus.sharepolite.SharePolite/queryShareRecord', data, errorback);
  },
  // 查询类型不为分享的商品
  queryNoShareGoods(data, errorback) {
    return request._post('/shop/plus.sharepolite.SharePolite/quertyNoShareGoods', data, errorback);
  },
  // 修改单一分享商品属性
  editShareGoods(data, errorback) {
    return request._post('/shop/plus.sharepolite.SharePolite/editShareGoods', data, errorback);
  },
  // 添加分享商品
  addShareGoods(data, errorback) {
    return request._post('/shop/plus.sharepolite.SharePolite/addShareGoods', data, errorback);
  }
}
export default ShareApi;



// WEBPACK FOOTER //
// ./src/api/sharepolite.js